import * as React from 'react';

import {
  VoiceboxResponseAction,
  VoiceboxResponseMessage,
} from 'bones/constants/voicebox/message';

export interface VoiceboxReasoningStep {
  summary: string;
  text: string;
}

export const useReasoningStepsFromMessage = ({
  action,
  message,
}: {
  action: VoiceboxResponseAction | undefined;
  message: VoiceboxResponseMessage | undefined;
}) =>
  React.useMemo(() => {
    const steps: VoiceboxReasoningStep[] = [];
    if (!action || !message) {
      return steps;
    }

    try {
      const values: Array<{
        // eslint-disable-next-line camelcase
        output_text_friendly?: string;
        // eslint-disable-next-line camelcase
        output_text?: string;
        summary?: string;
      }> = JSON.parse(action.value);

      values.forEach((value, valueIdx) => {
        const summary = value.summary || '';
        const text = value.output_text_friendly || value.output_text || '';

        if (valueIdx === values.length - 1 && text === message.result) {
          // remove the last intermediate step if it matches the final message text
          return;
        }

        if (summary || text) {
          steps.push({ summary, text });
        }
      });
    } catch (err) {
      console.warn('Problem loading reasoning action', err);
    }

    return steps;
  }, [action, message]);
